import {$, w} from './constants';

export function blockScroll() {

	$('.block_JS').each(function() {
		var scrollTop     = $(window).scrollTop()
		var elementOffset = $(this).offset().top
		var distance      = Math.round(elementOffset - scrollTop)
		var height 	      = Math.round($(this).height())
		var id			  = $(this).find('.block_anchor_JS').attr('id')
		
		// console.log($(this).find('.block_anchor_JS').attr('id'), distance, distance+height-80)

		if (distance <= 170 && (distance+height-80) > 0) {
			//console.log('.block_link_JS[href="'+id+'"]')
			$('.block_link_JS[href="#'+id+'"]').addClass('active')
		} else {
			$('.block_link_JS[href="#'+id+'"]').removeClass('active')
		}
	})
	//console.log('')

}